export default __webpack_public_path__ + "static/media/secretariaCultura.b8c48d13.png";